import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../Assests/nm logo.svg"; // Adjust the path if necessary
import { Auth } from "aws-amplify";

function Header() {
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();

  const redirectUrl = localStorage.getItem("redirect_url");
  console.log("Redirect URL:", redirectUrl);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const userinfo = await Auth.currentUserInfo();
        console.log("userinfo", userinfo);
        console.log("user", user);
        console.log("userAttributes", user.attributes);

        if (user && user.attributes) {
          const { given_name, family_name } = user.attributes;
          setUserName(`${given_name} ${family_name}`);
        }
      } catch (err) {
        console.error("Error fetching user info:", err);
        setUserName("");
      }
    };

    fetchUserInfo();
  }, []);

  const logout = async () => {
    try {
      await Auth.signOut();
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <AppBar
      position="static"
      color="transparent"
      sx={{ boxShadow: "none", borderBottom: "1px solid #3f506b" }}
    >
      <Toolbar>
        {/* Logo on the left */}
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
          <img src={logo} alt="Logo" className="header-img" />
        </Box>

        {/* Show Link and Buttons Only When Logged In */}
        {userName && (
          <>
            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
              <Button
                component="a"
                href={redirectUrl || "#"} // Fallback in case redirectUrl is null
                target="_blank" // Opens in a new tab
                rel="noopener noreferrer" // Security best practice for external links
                sx={{ color: "black", marginRight: 2 }}
              >
                NMGOPS Portal Website Link
              </Button>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button sx={{ color: "black" }}>
                {userName} {/* Display full name */}
              </Button>
              <Button onClick={logout} sx={{ color: "black" }}>
                Logout
              </Button>
            </Box>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Header;
